export default "__VITE_ASSET__CGb6jquC__"